export default __webpack_public_path__ + "static/media/order.375ab971.svg";